import Papa from "papaparse";

function checkHeaderFormat(array1, array2) {
  // Convert arrays to lowercase sets for case-insensitive comparison
  const set1 = new Set(array1);
  const set2 = new Set(array2);

  // Check if all strings from set1 are present in set2
  for (let string of set1) {
    if (!set2.has(string)) {
      return false; // Found a string that is not present in set2, return false
    }
  }

  return true; // All strings from set1 are present in set2
}

export function checkNull(item, keys) {
  const keysToCheck = keys.split(",");
  if (!Array.isArray(keysToCheck)) {
    throw new Error("keysToCheck must be an array");
  }

  return keysToCheck.some((key) => item[key] === null);
}

const CorrectFormatCar = {
  car_id: "",
  make: "",
  model: "",
  grade: "",
  body: "",
  fuel: "",
  description: "",
  engine: "",
  power: "",
  transmission: "",
  drivetrain: "",
  speed: "",
  maxspeed: "",
  consumption: "",
  co2: "",
  fuelron: "",
  fueltank: "",
  erange: "",
  warranty: "",
  country: "",
  length: "",
  width: "",
  height: "",
  wheelbase: "",
  seats: "",
  kerbweight: "",
  cargo: "",
  ancap: 0,
  airbags: 0,
  spare: "",
  alternative1: "",
  alternative2: "",
  alternative3: "",
};

export function validateCSV(file) {
  return new Promise((resolve, reject) => {
    try {
      Papa.parse(file, {
        header: true,
        dynamicTyping: true,
        complete: (results) => {
          const { data, meta } = results;

          console.log(meta.fields);

          if (!checkHeaderFormat(Object.keys(CorrectFormatCar), meta.fields))
            return reject({
              message:
                "Please make sure these columns are present car_id,make,model,grade,body,fuel,description,engine,power,transmission,drivetrain,speed,maxspeed,consumption,co2,fuelron,fueltank,erange,warranty,country,length,width,height,wheelbase,seats,kerbweight,cargo,ancap,airbags,spare,alternative1,alternative2,alternative3. Column names are case sensitive",
              error: {},
            });

          let validDataCount = 0,
            invalidDataCount = 0;

          const validData = [];

          data.forEach((item) => {
            if (
              checkNull(
                item,
                "car_id,make,model,grade,body,fuel,description,engine,power,transmission,drivetrain,speed,maxspeed,consumption,co2,fuelron,fueltank,erange,warranty,country,length,width,height,wheelbase,seats,kerbweight,cargo,ancap,airbags,spare,alternative1,alternative2,alternative3"
              )
            ) {
              invalidDataCount += 1;
            } else {
              validDataCount += 1;
              if (item.airbags === "NA") {
                console.log(item);
                item.airbags = -1; // TBC
              }

              if (item.airbags === "TBC") {
                item.airbags = -1; // TBC
              }

              // if (item.seats === "TBC") item.seats = -1; // TBC
              if (item.ancap === "NA") item.ancap = -1; // NA
              validData.push(item);
            }
          });

          resolve({
            validDataCount,
            invalidDataCount,
            validData,
          });
        },
      });
    } catch (error) {
      reject({
        message: "File could not be parsed",
        error,
      });
    }
  });
}
